import type { SmartCreationChatStoreApi } from '@atlassian/smart-creation/smart-creation-chat-store-api';

import { processConversationMessages, useChatStore, useChatStoreActions } from '../main';

export function useSmartCreationChatStoreApi(): SmartCreationChatStoreApi {
	const [{ currentConversationId, conversations }] = useChatStore();
	const {
		createConversationOptimistically,
		setSelectedConversation,
		sendMessage,
		abortRequests,
		seedConversation,
	} = useChatStoreActions();

	const activeConversation = conversations[currentConversationId];

	return {
		createConversationOptimistically,
		setSelectedConversation,
		abortRequests,
		activeConversationId: currentConversationId,
		activeConversation,
		sendMessage,
		seedConversation,
		processConversationMessages,
	};
}
